import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=296c0f3c&"
import script from "./FeedbackModal.vue?vue&type=script&lang=js&"
export * from "./FeedbackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296c0f3c')) {
      api.createRecord('296c0f3c', component.options)
    } else {
      api.reload('296c0f3c', component.options)
    }
    module.hot.accept("./FeedbackModal.vue?vue&type=template&id=296c0f3c&", function () {
      api.rerender('296c0f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/FeedbackModal.vue"
export default component.exports